import {Styles} from 'appearance'
import {styled} from '@mui/material/styles'
import Drawer from '@mui/material/Drawer'

export const SideMenuDrawer = styled(Drawer)`
    width: ${Styles.DRAWER_WIDTH};
    flex-shrink: 0;
`
